import { FormattedMessage } from 'react-intl';
import { Grid, Stack } from 'components/ui';
import { GrayCard } from 'components/styles_components/card';
import {
  CardOptionTypography,
  CardOptionHintTypography,
} from 'components/styles_components/typography';
import Ratio from 'components/compliance_stats/ratio';

const ComplianceRatioCard = ({ complianceRatio, label }) => (
  <Grid size={{ xs: 6, lg: 3 }}>
    <GrayCard>
      <Stack>
        <CardOptionTypography>
          <FormattedMessage id="inspection.complianceRatio" />
        </CardOptionTypography>
        <Ratio complianceRatio={complianceRatio} />
        <CardOptionHintTypography>
          {label}
        </CardOptionHintTypography>
      </Stack>
    </GrayCard>
  </Grid>
);

export default ComplianceRatioCard;
